import site from './profile/es/site';
import footer from './profile/es/footer';
import home from './profile/es/home';
import about from './profile/es/about';
import projectsPage from './profile/es/projectsPage';
import projects from './profile/es/projects';
import expertise from './profile/es/expertise';
import contact from './profile/es/contact';

const profileContentEs = {
  site,
  footer,
  home,
  about,
  projectsPage,
  projects,
  expertise,
  contact,
};

export default profileContentEs;
